import React from "react";

import PageMetaData from "../../components/PageMetaData/PageMetaData.js";
import TitleMain from "../../components/TitleMain/TitleMain.js";

const Profile = () => {
  return (
    <>
      <PageMetaData title={"Profile | jBot"} />
      <TitleMain>Profile</TitleMain>
    </>
  );
};

export default Profile;
